import { isFeatureEnable } from './features-enabling';
import { getBrowserHtmlContent } from './browser-utils';
import { updateQueryStringParameters } from './url-utils';
import { RootStore } from './stores/root.store';

export function canInstallShortcut(
  config?: FormatConfig,
  isAfterBrowser: boolean = false
): boolean {
  const isEnabledAfterBrowser =
    config?.icon &&
    config.icon.isAllowedAfterBrowser === true &&
    isFeatureEnable('installIconAfterBrowser') &&
    config.browser === 'browser';

  if (
    (!isAfterBrowser && isFeatureEnable('installIcon')) ||
    (isAfterBrowser && isEnabledAfterBrowser) ||
    config?.icon.forceInstall
  ) {
    return (
      RootStore.getInstance().adContainerStore.adContainerPort.hasCmd(
        'ogyCreateShortcut'
      ) &&
      Boolean(config?.icon) &&
      Boolean(config?.icon.useIcon) &&
      Boolean(config?.icon.url) &&
      Boolean(config?.icon.name) &&
      Boolean(config?.icon.identifier)
    );
  }
  return false;
}

interface InstallShortcutOptions {
  forceRedirectUrl?: string;
  isAfterBrowser?: boolean;
  forceResolve?: boolean;
}

export function installShortcut(
  adOptions: FormatOptions,
  config?: FormatConfig,
  options: InstallShortcutOptions = {}
): Promise<any> {
  if (
    !isFeatureEnable('installIcon') &&
    !isFeatureEnable('installIconAfterBrowser')
  ) {
    return Promise.resolve();
  }

  const {
    forceRedirectUrl,
    isAfterBrowser = false,
    forceResolve = false
  } = options;

  return new Promise((resolve, reject) => {
    if (!canInstallShortcut(config, isAfterBrowser)) {
      return reject(new Error('Cannot create shortcut, missing parameters'));
    }

    const clickUrl = isAfterBrowser ? config?.url : config?.clickUrl;

    const iconClickUrl = updateQueryStringParameters(clickUrl || '', {
      force_redirect: forceRedirectUrl ? forceRedirectUrl : '',
      source: 'icon'
    });

    const iconProperties = {
      content: getBrowserHtmlContent(adOptions, iconClickUrl),
      name: config?.icon.name,
      id: config?.icon.identifier,
      icon: config?.icon.url
    };

    RootStore.getInstance().adContainerStore.adContainerPort.ogyCreateShortcut(
      iconProperties,
      (err: any, res: any) => {
        if (err) {
          return reject(err);
        }
        // Yet this is broken, we never receive a callback from SDK
        resolve(res);
      }
    );

    if (forceResolve) {
      resolve(undefined);
    }
  });
}
